/**
 * Consentement aux traceurs, côté socle.
 *
 * Le bloc reqst/cookie-bar recueille le choix et l'écrit dans son cookie ;
 * ce module le rejoue vers Google Consent Mode à chaque page, avant que la
 * moindre balise ne se déclenche. Sans lui, un consentement donné hier serait
 * oublié dès le rechargement suivant.
 *
 * Le thème n'impose aucune balise : `gtag` peut très bien ne jamais exister.
 * La navette est posée quand même, pour qu'un gestionnaire ajouté plus tard
 * retrouve l'état dans le dataLayer.
 */

const COOKIE = 'reqst_cookieconsent';

/** Axes du Consent Mode v2, tous refusés tant que rien n'a été répondu. */
const PAR_DEFAUT = {
	ad_storage: 'denied',
	ad_user_data: 'denied',
	ad_personalization: 'denied',
	analytics_storage: 'denied',
};

function lireConsentement() {
	const trouve = document.cookie
		.split( '; ' )
		.find( ( c ) => c.startsWith( COOKIE + '=' ) );

	if ( ! trouve ) {
		return null;
	}

	try {
		return JSON.parse(
			decodeURIComponent( trouve.split( '=' ).slice( 1 ).join( '=' ) )
		);
	} catch {
		// Cookie illisible — traité comme une absence de réponse.
		return null;
	}
}

/**
 * Dit si le visiteur est à laisser tranquille.
 *
 * « Do Not Track » est une demande explicite, elle prime sur le bandeau. La
 * barre d'administration signale un agent de la mairie : ses passages ne
 * doivent pas gonfler les statistiques du site.
 */
function aExclure() {
	const dnt = navigator.doNotTrack || window.doNotTrack;

	return (
		'yes' === dnt ||
		'1' === dnt ||
		null !== document.querySelector( '#wpadminbar' )
	);
}

export function initCookies() {
	window.dataLayer = window.dataLayer || [];

	if ( 'function' !== typeof window.gtag ) {
		window.gtag = function () {
			// eslint-disable-next-line prefer-rest-params
			window.dataLayer.push( arguments );
		};
	}

	if ( aExclure() ) {
		window.gtag( 'consent', 'update', PAR_DEFAUT );
		return false;
	}

	const acquis = lireConsentement();

	if ( ! acquis ) {
		return false;
	}

	window.gtag( 'consent', 'update', {
		ad_storage: acquis.ad_storage ?? 'denied',
		ad_user_data: acquis.ad_user_data ?? 'denied',
		ad_personalization: acquis.ad_personalization ?? 'denied',
		analytics_storage: acquis.analytics_storage ?? 'denied',
	} );

	return true;
}
